import NotFound from './NotFoundTheme';

export default NotFound;
